// extracted by mini-css-extract-plugin
module.exports = {"partnersContainer":"our-partner-list_partnersContainer__oO9Ee"};